import { Button, Modal } from "components"
import { CreatePage } from "pages/Card/Transaction/CreateNewEmployee/components"
import { Fragment } from "react"
import { TbPlus } from "react-icons/tb"
import { useToggle } from "utils"

export function CreateManagerModal(params: {
  refetch: () => void
}): JSX.Element {
  // Hooks
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <Button color="primary" permission="AT021" className="px-2" onClick={toggle}>
        <TbPlus size={24} />
      </Button>

      {isActive && (
        <Modal
          isOpen
          title="Create New Manager"
          size="full"
          closeModal={() => {
            toggle()
            params.refetch()
          }}
        >
          <Modal.Body>
            <CreatePage asModal />
          </Modal.Body>
        </Modal>
      )}
    </Fragment>
  )
}
